import './FunctionCell_Empty.scss';

export default function FunctionCell_Empty(props) {
    return (
        <div className="gridFunctionCell">
        </div>
    )
}
